import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import withStyles from '@mui/styles/withStyles';
import React from 'react';
import { NOTIFICATION_AGREEMENT } from '../../constants/index';
import { NOTIFICATION_TYPE } from '../../constants/notification';

import '../../styles/Card.scss';
import './index.scss';

const buttonStyles = {
  root: {
    float: 'right',
    backgroundColor: '#f1f0ef',
    borderRadius: '0.5em',
    padding: '0.8em',
    margin: '0.5em',
    color: '#4f4f4f',
    textTransform: 'none',
    fontSize: '0.8em',
  },
};

const StyledButton = withStyles(buttonStyles)(Button);

const formControlLabelStyles = {
  label: {
    fontSize: '0.9em',
    userSelect: 'none',
  },
};

const StyledFormControlLabel = withStyles(formControlLabelStyles)(FormControlLabel);

type Props = {
  content: string,
  isChecked: boolean,
  notificationType: NOTIFICATION_TYPE,
  onCheckboxChange: () => void,
  onPrevClick: () => void,
  onNextClick: () => void,
  onFinalClick: () => void,
};

/**
 * Displays the Notification in the form of a card.
 */
class Notification extends React.PureComponent<Props> {
  buttonSwitch = (notificationType) => {
    switch (notificationType) {
      case NOTIFICATION_TYPE.FIRST:
        return (
          <StyledButton
            className="notification-button"
            onClick={this.props.onNextClick}
            data-cy="notification-button"
          >
            Next
          </StyledButton>
        );
      case NOTIFICATION_TYPE.MID:
        return (
          <>
            <StyledButton
              className="notification-button-prev"
              onClick={this.props.onPrevClick}
              data-cy="notification-button-prev"
            >
              Previous
            </StyledButton>
            <StyledButton
              className="notification-button"
              onClick={this.props.onNextClick}
              data-cy="notification-button"
            >
              Next
            </StyledButton>
          </>
        );
      case NOTIFICATION_TYPE.FINAL:
        return (
          <>
            <StyledButton
              className="notification-button-prev"
              onClick={this.props.onPrevClick}
              data-cy="notification-button-prev"
            >
              Previous
            </StyledButton>
            <StyledButton
              className="notification-button"
              onClick={this.props.onFinalClick}
              data-cy="notification-button"
            >
              Done
            </StyledButton>
          </>
        );
      default:
        return (
          <StyledButton
            className="notification-button"
            onClick={this.props.onFinalClick}
            data-cy="notification-button"
          >
            Done
          </StyledButton>
        );
    }
  };

  render() {
    const { notificationType } = this.props;
    return (
      <Dialog
        data-cy="notification-backdrop"
        open
        maxWidth="md"
        // this props sets up the class name for the card
        PaperProps={{
          className: 'notification',
        }}
      >
        {notificationType === NOTIFICATION_TYPE.ACK ? (
          <div className="notification-card" data-cy="notification-container">
            {/* eslint-disable react/no-danger */}
            <div
              className="notification-card-content"
              dangerouslySetInnerHTML={{ __html: this.props.content }}
              data-cy="notification-content"
            />
            <Divider />
            <div className="notification-card-footer-ack" data-cy="notification-footer-ack">
              <FormGroup row className="notification-checkbox" data-cy="notification-checkbox">
                <StyledFormControlLabel
                  control={(
                    <Checkbox
                      color="primary"
                      checked={this.props.isChecked}
                      onChange={this.props.onCheckboxChange}
                    />
                  )}
                  label={NOTIFICATION_AGREEMENT}
                />
              </FormGroup>
              <StyledButton
                className="notification-button"
                onClick={this.props.onFinalClick}
                data-cy="notification-button"
                disabled={!this.props.isChecked}
              >
                Confirm
              </StyledButton>
            </div>
          </div>
        ) : (
          <div className="notification-card" data-cy="notification-container">
            {/* eslint-disable react/no-danger */}
            <div
              className="notification-card-content"
              dangerouslySetInnerHTML={{ __html: this.props.content }}
              data-cy="notification-content"
            />
            <Divider />
            <div className="notification-card-footer" data-cy="notification-footer">
              {this.buttonSwitch(this.props.notificationType)}
            </div>
          </div>
        )}
      </Dialog>
    );
  }
}

export default Notification;
